module.exports = __webpack_public_path__ + "static/media/22sqm.c201bc72.JPG";